export default "__VITE_ASSET__CAWfVq$w__"